import HttpBackend from 'i18next-http-backend'
import type { ReadCallback } from 'i18next'
import { canServerHaveLocale } from './serverLocales'

/**
 * `i18next-http-backend`, minus the requests the backend has already told us it
 * cannot answer. See `serverLocales.ts` for why that matters.
 */
export class GatedHttpBackend extends HttpBackend {
  // Three declared parameters, deliberately: i18next-chained-backend reads
  // `read.length` to tell a callback-style backend from a promise-style one, so
  // a default or rest parameter here would route this through the wrong path.
  read(language: string, namespace: string, callback: ReadCallback): void {
    if (!canServerHaveLocale(language)) {
      // A miss with no request. The chained backend moves on when a link yields
      // no data, which lands on the bundled `en-standard` — the same resources
      // the 404 fell through to, one round trip earlier.
      callback(null, false)
      return
    }
    super.read(language, namespace, callback)
  }
}
